// Every language a menu can be shown in. The original 16 have their own database columns and on/off flags
// (menu.en, menu.sp...); the rest are stored as JSON and switched on through menu.extra_languages. Item
// translations for all of them arrive as food['translation_' + code] / food['description_' + code].
// Keep in sync with MenuLanguages in menutranslator.

export const COLUMN_LANGUAGES = [
  { code: 'en', name: 'English', native: 'English' },
  { code: 'sp', name: 'Spanish', native: 'Español' },
  { code: 'zh', name: 'Chinese', native: '中文' },
  { code: 'fr', name: 'French', native: 'Français' },
  { code: 'ru', name: 'Russian', native: 'Русский' },
  { code: 'ar', name: 'Arabic', native: 'العربية' },
  { code: 'de', name: 'German', native: 'Deutsch' },
  { code: 'kr', name: 'Korean', native: '한국어' },
  { code: 'jp', name: 'Japanese', native: '日本語' },
  { code: 'nl', name: 'Dutch', native: 'Nederlands' },
  { code: 'it', name: 'Italian', native: 'Italiano' },
  { code: 'ca', name: 'Catalan', native: 'Català' },
  { code: 'ina', name: 'Indonesian', native: 'Bahasa Indonesia' },
  { code: 'gre', name: 'Greek', native: 'Ελληνικά' },
  { code: 'ro', name: 'Romanian', native: 'Română' },
  { code: 'pt', name: 'Portuguese', native: 'Português' }
]

export const EXTRA_LANGUAGES = [
  { code: 'hi', name: 'Hindi', native: 'हिन्दी' },
  { code: 'bn', name: 'Bengali', native: 'বাংলা' },
  { code: 'ur', name: 'Urdu', native: 'اردو' },
  { code: 'vi', name: 'Vietnamese', native: 'Tiếng Việt' },
  { code: 'tr', name: 'Turkish', native: 'Türkçe' },
  { code: 'th', name: 'Thai', native: 'ไทย' },
  { code: 'fil', name: 'Filipino', native: 'Filipino' },
  { code: 'fa', name: 'Persian', native: 'فارسی' },
  { code: 'ta', name: 'Tamil', native: 'தமிழ்' },
  { code: 'te', name: 'Telugu', native: 'తెలుగు' },
  { code: 'mr', name: 'Marathi', native: 'मराठी' },
  { code: 'gu', name: 'Gujarati', native: 'ગુજરાતી' },
  { code: 'kn', name: 'Kannada', native: 'ಕನ್ನಡ' },
  { code: 'pa', name: 'Punjabi', native: 'ਪੰਜਾਬੀ' },
  { code: 'sw', name: 'Swahili', native: 'Kiswahili' },
  { code: 'ha', name: 'Hausa', native: 'Hausa' },
  { code: 'am', name: 'Amharic', native: 'አማርኛ' },
  { code: 'yo', name: 'Yoruba', native: 'Yorùbá' },
  { code: 'zh_hant', name: 'Traditional Chinese', native: '繁體中文' },
  { code: 'ms', name: 'Malay', native: 'Bahasa Melayu' },
  { code: 'pl', name: 'Polish', native: 'Polski' },
  { code: 'uk', name: 'Ukrainian', native: 'Українська' },
  { code: 'he', name: 'Hebrew', native: 'עברית' },
  { code: 'cs', name: 'Czech', native: 'Čeština' },
  { code: 'sv', name: 'Swedish', native: 'Svenska' },
  { code: 'da', name: 'Danish', native: 'Dansk' },
  { code: 'no', name: 'Norwegian', native: 'Norsk' },
  { code: 'fi', name: 'Finnish', native: 'Suomi' },
  { code: 'hu', name: 'Hungarian', native: 'Magyar' },
  { code: 'km', name: 'Khmer', native: 'ភាសាខ្មែរ' },
  { code: 'my', name: 'Burmese', native: 'မြန်မာ' },
  { code: 'ne', name: 'Nepali', native: 'नेपाली' }
]

const BY_CODE = Object.fromEntries([...COLUMN_LANGUAGES, ...EXTRA_LANGUAGES].map(language => [language.code, language]))
const RTL_CODES = ['ar', 'ur', 'fa', 'he']

export function isExtraLanguage(code) {
  return EXTRA_LANGUAGES.some(language => language.code === code)
}

export function englishName(code) {
  return BY_CODE[code] ? BY_CODE[code].name : code
}

export function nativeName(code) {
  return BY_CODE[code] ? BY_CODE[code].native : code
}

export function isRtl(code) {
  return RTL_CODES.includes(code)
}

// Interface text (translations.js) has the original languages only; any other language reads English.
export function withEnglishFallback(phrases) {
  return Object.fromEntries(Object.entries(phrases).map(([key, byLanguage]) => [
    key,
    byLanguage && typeof byLanguage === 'object'
      ? new Proxy(byLanguage, { get: (target, prop) => (typeof prop !== 'string' || prop in target ? target[prop] : target.en) })
      : byLanguage
  ]))
}
